// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `
    <svg width="20px" height="16px" viewBox="0 0 20 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>IconSliders</title>
        <g stroke="none" fill-rule="evenodd">
            <path d="M3.09451311,12.25 C3.42754521,10.9560796 4.60212043,10 6,10 C7.39787957,10 8.57245479,10.9560796 8.90548689,12.25 L19.2403984,12.25 C19.6599148,12.25 20,12.5828986 20,13 C20,13.4142136 19.6695492,13.75 19.2403984,13.75 L8.90548689,13.75 C8.57245479,15.0439204 7.39787957,16 6,16 C4.60212043,16 3.42754521,15.0439204 3.09451311,13.75 L0.759601593,13.75 C0.340085217,13.75 0,13.4171014 0,13 C0,12.5857864 0.330450833,12.25 0.759601593,12.25 L3.09451311,12.25 Z M6,15 C7.1045695,15 8,14.1045695 8,13 C8,11.8954305 7.1045695,11 6,11 C4.8954305,11 4,11.8954305 4,13 C4,14.1045695 4.8954305,15 6,15 Z"></path>
            <path d="M11.0945131,2.25 C11.4275452,0.95607959 12.6021204,0 14,0 C15.3978796,0 16.5724548,0.95607959 16.9054869,2.25 L19.2403984,2.25 C19.6599148,2.25 20,2.58289862 20,3 C20,3.41421356 19.6695492,3.75 19.2403984,3.75 L16.9054869,3.75 C16.5724548,5.04392041 15.3978796,6 14,6 C12.6021204,6 11.4275452,5.04392041 11.0945131,3.75 L0.759601593,3.75 C0.340085217,3.75 0,3.41710138 0,3 C0,2.58578644 0.330450833,2.25 0.759601593,2.25 L11.0945131,2.25 Z M14,5 C15.1045695,5 16,4.1045695 16,3 C16,1.8954305 15.1045695,1 14,1 C12.8954305,1 12,1.8954305 12,3 C12,4.1045695 12.8954305,5 14,5 Z"></path>
        </g>
    </svg>
    `
};

export const IconSliders = () => <span dangerouslySetInnerHTML={icon} />;

export default IconSliders;
